import * as yup from 'yup'

const ResetPasswordValidator = yup.object().shape({
  email: yup.string().email().required(),
})

export default ResetPasswordValidator
